module.exports = __webpack_public_path__ + "img/Windows-active.9b07c53.svg";